import { useSession } from "@/session";
import { Empty, Panel, panel } from "@/ui";

export function Admin() {
  const { user } = useSession();
  if (user?.role !== "owner" && user?.role !== "admin") {
    return (
      <div style={{ ...panel, padding: "20px" }}>
        <Empty>This console is for platform staff.</Empty>
      </div>
    );
  }
  return (
    <Panel title="Platform administration">
      <Empty>Coming soon.</Empty>
    </Panel>
  );
}
